import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  Settings,
  UserRound,
  Palette,
  Languages,
  MessageSquare,
} from "lucide-react";

import AccountSettings from "./AccountSettings";
import AppearanceSettings from "./AppearanceSettings";
import LanguageSettings from "./LanguageSettings";
import FeedbackSettings from "./FeedbackSettings";

import "./settings.css";

export default function SettingsPage() {
  const navigate = useNavigate();

  return (
    <div className="settings-page">
      <div className="settings-container">

        {/* ================================
            HEADER
        ================================= */}

        <header className="settings-header">

          <button
            className="back-btn"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <ArrowLeft size={20} />
          </button>

          <div className="settings-header-icon">
            <Settings size={21} />
          </div>

          <div className="settings-header-content">
            <h1>Settings</h1>

            <p className="subtitle">
              Manage your Civilink account preferences
            </p>
          </div>

        </header>

        {/* ================================
            ACCOUNT
        ================================= */}

        <div className="settings-section">

          <div className="settings-section-heading">
            <div className="settings-section-icon">
              <UserRound size={16} />
            </div>

            <span>ACCOUNT</span>
          </div>

          <AccountSettings />

        </div>

        {/* ================================
            APPEARANCE
        ================================= */}

        <div className="settings-section">

          <div className="settings-section-heading">
            <div className="settings-section-icon">
              <Palette size={16} />
            </div>

            <span>APPEARANCE</span>
          </div>

          <AppearanceSettings />

        </div>

        {/* ================================
            LANGUAGE
        ================================= */}

        <div className="settings-section">

          <div className="settings-section-heading">
            <div className="settings-section-icon">
              <Languages size={16} />
            </div>

            <span>LANGUAGE</span>
          </div>

          <LanguageSettings />

        </div>

        {/* ================================
            FEEDBACK
        ================================= */}

        <div className="settings-section">

          <div className="settings-section-heading">
            <div className="settings-section-icon">
              <MessageSquare size={16} />
            </div>

            <span>FEEDBACK</span>
          </div>

          <FeedbackSettings />

        </div>

        {/* ================================
            FOOTER
        ================================= */}

        <footer className="settings-footer">

          <div className="settings-footer-brand">
            <span className="settings-footer-dot" />
            CIVILINK
          </div>

          <p>
            Your construction & property platform
          </p>

        </footer>

      </div>
    </div>
  );
}